<template>
	<div
		class="auto-complete-wrapper"
		@mouseover="isSelecting = true"
		@mouseout="isSelecting = false"
		v-click-outside="onFocusOut"
	>
		<layout-input
			class="input"
			:regex="regex"
			:type="type"
			:place-holder="placeHolder"
			:value="stringValue"
			v-on:input="doSearching"
			:on-blur="onFocusOut"
			:on-focus="onFocus"
			:style="{ width: width }"
		/>

		<div class="drop-down">
			<svg
				version="1.1"
				id="Capa_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				width="10px"
				height="10px"
				viewBox="0 0 255 255"
				style="enable-background:new 0 0 255 255;"
				xml:space="preserve"
			>
				<g>
					<g id="arrow-drop-down">
						<polygon points="0,63.75 127.5,191.25 255,63.75" />
					</g>
				</g>
			</svg>
		</div>

		<div class="auto-complete-wrap">
			<div class="auto-complete" v-if="show">
				<div class="shape">
					<div
						v-for="(item, index) in result"
						:key="index"
						class="item-wrapper"
						@click.stop="() => { selectAutoComplete(item) }"
					>
						<p class="item">{{ item[trackName] }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import LayoutInput from "@/spa/components/LayoutInput";

Vue.directive("click-outside", {
	bind: (el, binding, vnode) => {
		el.clickOutsideEvent = event => {
			// here I check that click was outside the el and his childrens
			if (!(el === event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	unbind: el => {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	}
});

export default {
	name: "LayoutAsyncAutoComplete",
	components: {
		LayoutInput
	},
	props: {
		apiUrl: {
			type: String,
			isRequired: true
		},
		trackName: {
			type: String,
			isRequired: true
		},
		httpOptions: {
			type: Object,
			default: () => ({})
		},
		trackBy: {
			type: String,
			default: "id"
		},
		type: {
			type: String,
			default: "text"
		},
		value: {
			type: [String, Number, Object]
		},
		placeHolder: {
			type: String,
			default: ""
		},
		regex: {
			type: String,
			default: ""
		},
		width: {
			type: String,
			default: ""
		},
		callback: {
			type: Function
		}
	},
	watch: {
		selectItem(value) {
			this.$emit("input", value[this.trackBy]);
		}
	},
	methods: {
		async doSearching(text) {
			this.stringValue = text;

			console.log("this.apiUrl", this.apiUrl);

			const result = await axios.get(
				`${this.apiUrl}?text=${text}&page=${this.page}&per_page=${this.perPage}`,
				this.httpOptions
			);

			this.result = result.data.result.rows;
			this.showAutoComplete();
		},

		async onFocus() {
			await this.doSearching(this.stringValue || "");
		},

		onFocusOut() {
			if (!this.isSelecting) {
				this.hideAutoComplete();
			}
		},

		showAutoComplete() {
			this.show = true;
		},

		hideAutoComplete() {
			this.show = false;
		},

		selectAutoComplete(item) {
			this.selectItem = item;
			this.stringValue = item[this.trackName];
			if (this.callback) {
				this.callback(item);
			}
			this.hideAutoComplete();
		}
	},
	data() {
		return {
			result: [],

			show: false,
			stringValue: "",
			selectItem: null,
			isSelecting: false,

			page: 1,
			perPage: 9999
		};
	},
	async created() {
		console.log("created this.apiUrl", this.apiUrl);

		const result = await axios.get(`${this.apiUrl}`, this.httpOptions);

		result.data.result.rows.some(item => {
			const base = parseInt(item[this.trackBy], 10);
			const target = parseInt(this.value, 10);

			if (base === target) {
				this.selectItem = item;
				this.stringValue = item[this.trackName];
			}

			return base === target;
		});
	}
};
</script>

<style lang="scss" scoped>
.auto-complete-wrapper {
	position: relative;

	width: 100%;
	height: auto;

	.input {
		padding-left: 15px;

		box-sizing: border-box;
	}

	.drop-down {
		position: absolute;
		right: 10px;
		top: 50%;

		transform: translate(-50%, -50%);
	}

	.auto-complete {
		position: absolute;
		width: 100%;
		height: auto;

		z-index: 100;

		.shape {
			width: 100%;
			height: auto;
			max-height: 300px;
			overflow-y: scroll;
			background: rgb(255, 255, 255);
			box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);

			.item-wrapper {
				width: 100%;
				box-sizing: border-box;
				padding: 0 16px;
				cursor: pointer;
				background: rgb(255, 255, 255);
				&:hover {
					background: rgb(41, 155, 252);
					.item {
						color: #ffffff;
					}
				}
				.item {
					position: relative;
					box-sizing: border-box;
					width: 100%;
					height: 100%;
					font-size: 14px;
					padding: 12px 16px;
					margin: 0;
					color: #666666;
					border-bottom: 1px solid rgba(0, 0, 0, 0.08);
				}
			}
		}
	}
	.invisible-background {
		position: fixed;
		z-index: 99;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutAsyncAutoComplete.vue